<template>
  <table class="table-pin-rows table-md mb-4 table">
    <thead>
      <tr>
        <th>Chạy với</th>
        <th>Thời gian tạo</th>
        <th>Câu lệnh</th>
      </tr>
    </thead>
    <tbody class="bg-base-200">
      <tr
        v-for="action in actions"
        :key="action.id"
        class="cursor-pointer"
        @click="action.status === 'complete' && show_cmd_info(action.id)"
      >
        <td>
          <div class="kbd">{{ action.run_with }}</div>
        </td>
        <td>{{ dayjs(action.created).fromNow() }}</td>
        <td>{{ action.args }}</td>
        <td>
          <ActionStatus :status="action.status" />
        </td>
      </tr>
    </tbody>
  </table>
  <PaginationTemplate :total_pages="total_pages" />
</template>

<script setup lang="ts">
import dayjs from "dayjs";
import type { action } from "../ExplorerV2";
import PaginationTemplate from "@/components/PaginationTemplate.vue";
import ActionStatus from "../ExplorerV2/ActionStatus.vue";

const props = defineProps<{
  actions: action[];
  total_pages: number;
  show_cmd_info: (cmd_id: string | undefined) => void;
}>();
</script>
